const footerLinks = [
  {
    title: '漫画分类',
    links: ['韩漫', '日漫', '国漫', '恋爱', '热血', '奇幻', '悬疑', '古风'],
  },
  {
    title: '快捷入口',
    links: ['精选专题', '热门榜单', '新作推荐', '更新动态', 'APP下载', '常见问题'],
  },
  {
    title: '关于我们',
    links: ['平台介绍', '投稿合作', '版权声明', '隐私政策', '用户协议', '联系我们'],
  },
];

const partners = ['合作伙伴A', '合作伙伴B', '合作伙伴C', '合作伙伴D', '合作伙伴E', '合作伙伴F'];

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-book-read-line text-white text-sm"></i>
              </span>
              <span className="text-lg font-bold text-white font-heading">蛙漫漫画</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4 max-w-[260px]">
              蛙漫漫画汇聚海量韩漫、日漫、国漫等热门好看的漫画大全，各类漫画免费在线看，满足您的漫画阅读喜好。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-white transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-bold text-white mb-4 font-heading">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href={`#${link}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-800">
          <h4 className="text-sm font-bold text-background-300 mb-4 font-heading">合作伙伴</h4>
          <div className="flex flex-wrap gap-4">
            {partners.map((p) => (
              <span
                key={p}
                className="px-4 py-2 rounded-lg bg-background-800 text-background-500 text-xs font-medium"
              >
                {p}
              </span>
            ))}
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2022 - 2026 蛙漫漫画 WAMAN.COM 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <span>京ICP备XXXXXXXX号</span>
            <span>京公网安备XXXXXXXXXX号</span>
          </div>
        </div>
      </div>
    </footer>
  );
}